module.exports = __webpack_public_path__ + "abe89a98ea4287d6a65038f0b10aab54.svg";